import { render, staticRenderFns } from "./form-mp.vue?vue&type=template&id=16fa4924&"
import script from "./form-mp.vue?vue&type=script&lang=js&"
export * from "./form-mp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports